<template>
  <div class="system-builder__contact-dealer--scroll-wrap">
    <div class="system-builder__contact-dealer--dealers-container">

      <div class="system-builder__contact-dealer--final-nav">
        <span @click="editContactForm">Edit Contact Info</span>
      </div>

      <h4>
        <span v-if="sharedState.dealers === null">Submit the form below to find and get a quote from a local dealer!</span>
        <span class="system-builder__dealer-count" v-else-if="getNumberDealers === 1">
          Great! There is 1 dealer near {{sharedState.customerDetails.customerZip}}.
        </span>
        <span class="system-builder__dealer-count" v-else-if="getNumberDealers === 0">
          Sorry, there are no dealers located near{{sharedState.customerDetails.customerZip}}.
        </span>
        <span class="system-builder__dealer-count" v-else>
          Great! There are {{getNumberDealers}} dealers near {{sharedState.customerDetails.customerZip}}.
        </span>
      </h4>
      <p style="margin-bottom:25px;">Call, visit, or request an e-quote to get more information from your local dealer.</p>

      <div class="system-builder__contact-dealer--dealers-container-alt" v-if="sharedState.dealers === null">
        <spinner size="large" message="Loading dealers nearby..."></spinner>
      </div>

      <div class="system-builder__contact-dealer--dealer-items-container" v-else>
        <dealerItem v-for="(dealer, index) in sharedState.dealers" :key="dealer.ID" :dealerId="dealer.ID"
                    :dealerPro="dealer.custom_fields.tx_wpsl_store_category[0]"
                    :dealerPhone="checkPropForValue(dealer.custom_fields.wpsl_phone[0])"
                    :dealerEmail="dealer.custom_fields.wpsl_email[0]">
          <div slot="dealer-details">
            <h5>{{dealer.post_title}} - <span class="system-builder__dealer-distance">{{dealer.distance}} Miles</span></h5>
            <p>
              {{dealer.custom_fields.wpsl_address[0]}}<br>
              {{dealer.custom_fields.wpsl_city[0]}}, {{dealer.custom_fields.wpsl_state[0]}} {{dealer.custom_fields.wpsl_zip[0]}}<br>
              <span v-if="checkPropForValue !== false">{{dealer.custom_fields.wpsl_phone[0]}}</span>
            </p>
          </div>
        </dealerItem>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../store'
  import router from '../../router'
  import dealerItem from '../reusable/DealerItem.vue'
  import spinner from 'vue-simple-spinner'

  export default {
    components: {dealerItem, spinner},
    name: 'contactInfo',
    data () {
      return {
        sharedState: store.state,
        emailButtonLoading: false,
        emailSent: false
      }
    },
    methods: {
      goBackStep: function () {
        router.go(-1)

        // Get ID of step going to
        var stepName = ''
        var currentStepNumber = this.sharedState.currentStep.stepNumber

        for (var theStep in this.sharedState.steps) {
          if (this.sharedState.steps[theStep].stepNumber === currentStepNumber - 1) {
            stepName = this.sharedState.steps[theStep].id
          }
        }

        // Update to the correct state
        store.updateCurrentStateRoute(stepName)
      },
      editContactForm: function () {
        store.changeFormValidationState(false)
      },
      objectLength: function (object) {
        var length = 0
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            ++length
          }
        }
        return length
      },
      checkPropForValue: function (propVal) {
        // If prop value does not exist, give default value
        if (propVal === '' || propVal === undefined) {
          return false
        } else {
          return propVal
        }
      }
    },
    computed: {
      getNumberDealers: function () {
        return this.objectLength(this.sharedState.dealers)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DealerList.vue?bbd5e066